import { createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

import type { RootState } from 'store/store'

import { ReturnScreenObj, Task } from '../types'

export interface TasksState {
  taskDetail: Task
  facilityListForParentFilter: number[] // for storing orgids
  facilityListForParentFilter2: number[] // for community ids
  facilityListForParentFilter3: {
    userId: string
    name: string
    userName: string
    roles: string[]
  }[] // for userids
  configPageSelectedTab: number
  initialUserFilterLoading: boolean
  taskId: number
  selTab: string
  isKanbanBoardReload?: boolean
  returnScreenDetails?: ReturnScreenObj
  appliedTaskType: string[]
  appliedDueDateFrom: string | null
  appliedDueDateTo: string | null
}

const initialState: TasksState = {
  taskDetail: {},
  facilityListForParentFilter: [],
  facilityListForParentFilter2: [],
  facilityListForParentFilter3: [],
  configPageSelectedTab: 0,
  initialUserFilterLoading: false,
  taskId: 0,
  selTab: 'general',
  isKanbanBoardReload: false,
  returnScreenDetails: {},
  appliedTaskType: [],
  appliedDueDateFrom: null,
  appliedDueDateTo: null,
}
// slice
export const tasksSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    setTaskDetail: (state, action) => {
      state.taskDetail = action.payload
    },
    setFacilityListForParentFilter: (state, action) => {
      state.facilityListForParentFilter = action.payload
    },
    setFacilityListForParentFilter2: (state, action) => {
      state.facilityListForParentFilter2 = action.payload
    },
    setFacilityListForParentFilter3: (state, action) => {
      state.facilityListForParentFilter3 = action.payload
    },

    setSelectedTabInTempConfig: (state, action) => {
      state.configPageSelectedTab = action.payload
    },
    setInitialUserFilterLoading: (state, action) => {
      state.initialUserFilterLoading = action.payload
    },
    setTaskId: (state, action) => {
      state.taskId = action.payload
    },
    setSelectTab: (state, action) => {
      state.selTab = action.payload
    },
    setIsKanbanBoardReload: state => {
      state.isKanbanBoardReload = !state.isKanbanBoardReload
    },
    setReturnScreenDetails: (state, action) => {
      state.returnScreenDetails = action.payload
    },
    setAppliedTaskType: (state, action) => {
      state.appliedTaskType = action.payload
    },
    setAppliedDueDateFrom: (state, action) => {
      state.appliedDueDateFrom = action.payload
    },
    setAppliedDueDateTo: (state, action) => {
      state.appliedDueDateTo = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(PURGE, () => initialState)
  },
})

// Actions
export const tasksActions = {
  setTaskDetail: tasksSlice.actions.setTaskDetail,
  setFacilityListForParentFilter: tasksSlice.actions.setFacilityListForParentFilter,
  setFacilityListForParentFilter2: tasksSlice.actions.setFacilityListForParentFilter2,

  setFacilityListForParentFilter3: tasksSlice.actions.setFacilityListForParentFilter3,
  setSelectedTabInTempConfig: tasksSlice.actions.setSelectedTabInTempConfig,
  setInitialUserFilterLoading: tasksSlice.actions.setInitialUserFilterLoading,
  setTaskId: tasksSlice.actions.setTaskId,
  setSelectTab: tasksSlice.actions.setSelectTab,
  setIsKanbanBoardReload: tasksSlice.actions.setIsKanbanBoardReload,
  setReturnScreenDetails: tasksSlice.actions.setReturnScreenDetails,
  setAppliedTaskType: tasksSlice.actions.setAppliedTaskType,
  setAppliedDueDateFrom: tasksSlice.actions.setAppliedDueDateFrom,
  setAppliedDueDateTo: tasksSlice.actions.setAppliedDueDateTo,
}

// Selectors
export const selectTaskDetails = (state: RootState) => state.tasks.taskDetail
export const getFacilityListForParentFilter = (state: RootState) =>
  state.tasks.facilityListForParentFilter
export const getFacilityListForParentFilter2 = (state: RootState) =>
  state.tasks.facilityListForParentFilter2
export const getFacilityListForParentFilter3 = (state: RootState) =>
  state.tasks.facilityListForParentFilter3
export const getSelectedTabInTempConfig = (state: RootState) => state.tasks.configPageSelectedTab
export const getInitialUserFilterLoading = (state: RootState) =>
  state.tasks.initialUserFilterLoading
export const getTaskId = (state: RootState) => state.tasks.taskId
export const getSelTab = (state: RootState) => state.tasks.selTab
export const getIsKanbanBoardReload = (state: RootState) => state.tasks.isKanbanBoardReload
export const getReturnScreenDetails = (state: RootState) => state.tasks.returnScreenDetails
export const getAppliedTaskType = (state: RootState) => state.tasks.appliedTaskType
export const getAppliedDueDateFrom = (state: RootState) => state.tasks.appliedDueDateFrom
export const getAppliedDueDateTo = (state: RootState) => state.tasks.appliedDueDateTo
// Reducer
export default tasksSlice.reducer
